import { useRef, useCallback } from 'react';

const useExpiration = ({ expiration }: { expiration: number }) => {
    const expirationDate = useRef<number | null>(null);

    const updateExpirationDate = useCallback(() => {
        expirationDate.current = Date.now() + expiration;
    }, [expiration]);

    const getIsExpired = useCallback(() => {
        const now = Date.now();

        const isExpired =
            !expirationDate.current || now >= expirationDate.current;

        return isExpired;
    }, []);

    return { getIsExpired, updateExpirationDate };
};

export default useExpiration;
